













































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import { Device, PatientDetails, ScanResponseType } from "@/models";
import CoreAPI from "@/utils/core-api";
import EventBus from "@/utils/event-bus";
import { FOCUS_SEARCHBAR, CLEAR_ASSOCIATION_MESSAGE } from "@/utils/constants";
import * as modals from "@/utils/modals";
import { getPatientFullName } from "@/filters/patientName";

@Component
export default class Patient extends Vue {
  @Prop() readonly patient!: PatientDetails;
  @Prop() readonly device!: Device;
  @Prop() readonly scanFirst!: ScanResponseType;

  scanResponseType = ScanResponseType;

  get fullLocation() {
    const phi = this.patient.phi;
    const segments = [phi.pointOfCare, phi.room, phi.bed];
    return segments.filter(l => l).join("-");
  }

  // The birth date may come in with a time zone. If so, strip it out and treat it as UTC so that if the patient is
  // from a different time zone it doesn't change their birth date
  get birthDate() {
    const birthDate = this.patient.phi.birthDate;
    if (!birthDate) return birthDate;

    return birthDate.replace(/\+|-\d\d:\d\d/, "Z");
  }

  get canDisassociate() {
    return this.patient && this.scanFirst === ScanResponseType.DEVICE;
  }

  get patientName() {
    return getPatientFullName(this.patient);
  }

  async disassociate() {
    EventBus.$emit(CLEAR_ASSOCIATION_MESSAGE);

    try {
      const proceed = await modals.showRemoveAssociationModal(
        this.$bvModal,
        "Remove Patient",
        this.patientName,
        `ventilator ${this.device.name || this.device.serial}`
      );

      // If the user cancelled, nothing to do
      if (!proceed) return;

      try {
        await CoreAPI.associateDevice(this.device.serial, null);
        this.$emit("remove-patient");
      } catch (error) {
        if ((error as any).isNetworkError) {
          await modals.showLostConnectionModal(this.$bvModal);
        } else {
          console.error("Failed disassociating", error);
          await modals.showUnexpectedErrorModal(this.$bvModal);
        }
      }
    } finally {
      EventBus.$emit(FOCUS_SEARCHBAR);
    }
  }
}
